import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';
import {
  type IAdvancedSelectColumns,
  isPlainAdvancedSelectColumn,
} from '../IAdvancedSelectColumns.ts';

/** Opzione di una select sulle colonne: etichetta mostrata e id colonna. */
export interface IAdvancedSelectColumnOption {
  label: string;
  value: string;
}

/** Trasforma le colonne in opzioni select (label = etichetta, value = id). */
export function getAdvancedSelectColumnOptions(
  columns?: IAdvancedSelectColumns[],
): IAdvancedSelectColumnOption[] {
  return columns?.map(col => ({ label: col.label, value: col.id })) ?? [];
}

/**
 * Come `getAdvancedSelectColumnOptions` ma esclude le colonne RichText: usata
 * dove il valore deve essere univoco/confrontabile (il RichText non lo è).
 */
export function getAdvancedSelectUniqueValueColumnOptions(
  columns?: IAdvancedSelectColumns[],
): IAdvancedSelectColumnOption[] {
  return getAdvancedSelectColumnOptions(
    columns?.filter(isPlainAdvancedSelectColumn),
  );
}

/** Indica se la colonna con l'id dato è di tipo RichText. */
export function isAdvancedSelectRichTextColumn(
  columns: IAdvancedSelectColumns[] | undefined,
  columnId: string | undefined,
): boolean {
  if (!columnId) return false;
  return (
    columns?.some(
      column => column.id === columnId && column.type === Datatype.RichText,
    ) ?? false
  );
}
